import { Component } from '@angular/core';
import { VersionsService } from '@socrates/socrates-shared';

@Component({
	selector: 'app-footer',
	templateUrl: './appFooter.component.html',
	standalone: false,
})
export class AppFooterComponent {
	readonly today = new Date();

	constructor(private versionService: VersionsService) {}

	get versionLabel(): string {
		const name = this.versionService.versions?.appVersion?.name ?? '';
		const match = name.match(/(\d+\.\d+[\.\d]*)/);
		return match ? match[1] : name;
	}
}
